"use client";

import { useEffect } from "react";

export default function LeafletStyles() {
  useEffect(() => {
    // Load Leaflet CSS asynchronously to prevent render blocking
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
    link.integrity = "sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=";
    link.crossOrigin = "anonymous";
    
    // Add font-display: swap to prevent layout shift
    link.onload = () => {
      const style = document.createElement("style");
      style.textContent = `
        .leaflet-container {
          font-display: swap;
        }
      `;
      document.head.appendChild(style);
    };
    
    document.head.appendChild(link);
    
    return () => {
      // Cleanup if component unmounts
      const existingLink = document.querySelector('link[href*="leaflet.css"]');
      if (existingLink) {
        existingLink.remove();
      }
    };
  }, []);

  return null;
}
